<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-form
          @submit.prevent="
            employee == null ? (flags.confirmMails = true) : submit()
          "
        >
          <v-card-title class="headline gradiente lighten-2 elevation-3">
            <span class="white--text">{{ title }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex order-xs2 order-md2 xs12 md6>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                        :error-messages="nameErrors"
                        v-model="$v.userForm.firstName.$model"
                        :label="$t('employee.edit_employee_modal.first_name')"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        :error-messages="lastNameErrors"
                        v-model="$v.userForm.lastName.$model"
                        :label="$t('employee.edit_employee_modal.last_name')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        :error-messages="emailErrors"
                        v-model="$v.userForm.mail.$model"
                        :label="$t('employee.edit_employee_modal.email')"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        v-model="$v.userForm.webRole.$model"
                        :items="roles"
                        return-object
                        item-text="name"
                        :label="$t('employee.edit_employee_modal.role')"
                        outline
                        required
                        :error-messages="roleErrors"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex order-xs1 order-md2 xs8 offset-xs2 md6 offset-md0>
                  <v-layout
                    align-center
                    justify-center
                    row
                    fill-height
                    wrap
                    v-on:mouseover="flags.updateImage = true"
                    v-on:mouseleave="flags.updateImage = false"
                  >
                    <v-flex
                      style="text-align: center"
                      sm7
                      v-show="working.wImage"
                    >
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </v-flex>
                    <v-flex
                      v-show="!working.wImage"
                      xs7
                      style="border-radius: 50%"
                      id="parentContainerEmployeeImage"
                      :class="
                        !flags.changed &&
                        (!employee ||
                        !employee.imageStorage ||
                        !employee.imageStorage.miniObjUrl
                          ? 'gradiente'
                          : '')
                      "
                    >
                      <label id="img_edit_employee_default">
                        <v-img
                          v-if="
                            !employee ||
                            !employee.imageStorage ||
                            !employee.imageStorage.miniObjUrl
                          "
                          :src="
                            require('@/assets/panel/modals/AddPhotoIcon@3x.png')
                          "
                        ></v-img>
                        <v-img
                          style="border-radius: 50%; text-align: center"
                          v-else
                          :src="employee.imageStorage.miniObjUrl"
                        ></v-img>
                      </label>
                      <label
                        style="display: none; text-align: center"
                        id="img_edit_employee"
                      ></label>
                    </v-flex>
                    <br />
                    <v-flex xs7>
                      <v-expand-transition>
                        <v-btn
                          block
                          class="gradiente"
                          style="border-radius: 33px"
                          v-show="flags.updateImage"
                          dark
                          @click="modals.image = true"
                          >{{
                            !employee ||
                            !employee.imageStorage ||
                            !employee.imageStorage.miniObjUrl
                              ? $t('employee.edit_employee_modal.add_photo')
                              : $t('employee.edit_employee_modal.update')
                          }}</v-btn
                        >
                      </v-expand-transition>
                      <v-expand-transition>
                        <v-btn
                          block
                          class="gradiente"
                          style="border-radius: 33px"
                          v-show="
                            permits &&
                            permits['UPDATE_COLAB'] &&
                            flags.updateImage &&
                            employee !== null &&
                            employee !== undefined &&
                            employee.imageStorage &&
                            employee.imageStorage.miniObjUrl
                          "
                          dark
                          @click="modals.confirmDelete = true"
                        >
                          Borrar
                        </v-btn>
                      </v-expand-transition>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="working.wUpdate" flat @click="close">
              {{ $t('employee.edit_employee_modal.cancel') }}
            </v-btn>
            <v-btn
              :disabled="working.wUpdate"
              color="primary darken-1"
              type="submit"
              flat
            >
              {{ $t('employee.edit_employee_modal.save') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <loading v-model="working.wUpdate" text="Trabajando..."></loading>
    <success v-model="toast.success" text="Creación Exitosa"></success>
    <error v-model="toast.failed" :text="toast.eMessage" :time="6000"></error>
    <ConfirmMails
      v-model="flags.confirmMails"
      @desition="submit"
      title="Correo"
      description="¿Desea enviar correo de bienvenida al nuevo colaborador?"
    ></ConfirmMails>
    <editImage
      :title="userForm.img != null ? 'Editar imagen' : 'Añadir imagen'"
      v-on:loaded="processImage($event)"
      v-model="modals.image"
    ></editImage>
    <desition
      @desition="$event ? deletePhoto() : ''"
      v-model="modals.confirmDelete"
      title="Confirmación"
      description="Al realizar esta acción la foto del colaborador dejará de mostrarse y deberás añadir una nueva, ¿Estás seguro de realizar esta acción?"
    />
  </div>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators'
import desition from '../Dialogs/Confirm'
import ConfirmMails from '../Dialogs/ConfirmMails'
import error from '../Dialogs/Error.vue'
import loading from '../Dialogs/Loading.vue'
import success from '../Dialogs/Success.vue'
import editImage from '../Modals/EditImage'
export default {
  props: ['title', 'employee', 'value', 'roles', 'permits'],
  components: {
    loading,
    success,
    error,
    editImage,
    ConfirmMails,
    desition,
  },
  validations: {
    userForm: {
      firstName: { required },
      lastName: { required },
      mail: { required, email },
      webRole: { required },
    },
  },
  watch: {
    value() {
      if (this.value) {
        if (this.employee != null) {
          this.userForm.id = this.employee.id
          this.userForm.firstName = this.employee.firstName
          this.userForm.lastName = this.employee.lastName
          this.userForm.mail = this.employee.mail
          this.userForm.webRole = this.employee.webRole
        }
      }
    },
  },
  mounted() {},
  data: () => ({
    modals: {
      image: false,
      confirmDelete: false,
    },
    userForm: {
      firstName: '',
      lastName: '',
      mail: '',
      webRole: null,
    },
    userImg: null,
    working: {
      wUpdate: false,
      wImage: false,
    },
    toast: {
      success: false,
      failed: false,
      eMessage: '',
    },
    flags: {
      updateImage: false,
      confirmMails: false,
      changed: false,
    },
  }),
  methods: {
    deletePhoto() {
      this.$emit('deletePhoto', this.employee.id)
    },
    processImage(event) {
      this.working.wImage = true
      this.userForm.img = event.split(',')[1]
      document.getElementById(
        'img_edit_employee'
      ).innerHTML = `<img class="elevation-4" src="${event}" style='width: 120px; height: 120px; object-fit: cover; border-radius: 50%;'>`
      document.getElementById('img_edit_employee').style.display = 'block'
      document.getElementById('img_edit_employee_default').style.display =
        'none'
      this.working.wImage = false
      this.flags.changed = true
    },
    submit(event = null) {
      this.$v.userForm.$touch()
      if (!this.$v.userForm.$invalid) {
        this.working.wUpdate = true
        if (this.employee == null) {
          var obj = this.userForm
          obj.password = '123'
          obj.sendFlag = event
          this.$store
            .dispatch('employee/createEmployee', obj)
            .then((response) => {
              this.working.wUpdate = false
              this.toast.success = true
              this.$v.userForm.$reset()
              this.$emit('created', response.data.entity)
              this.close()
            })
            .catch((error) => {
              this.working.wUpdate = false
              this.toast.failed = true
              //  this.toast.eMessage = error.statusText;

              if (error.response) {
                switch (error.response.data.message) {
                  case 'Correo repetido':
                    this.toast.eMessage =
                      'El correo ya existe como colaborador, por favor añade uno nuevo.'
                    break
                  default:
                    this.toast.eMessage =
                      'No se pudo registrar debido a que el correo es inválido o inexistente o está deshabilitado, por favor verifica que sea correcto..'
                }
              }
              console.log(error)
            })
        } else {
          var obj = this.userForm
          obj.sendFlag = event
          this.$store
            .dispatch('employee/updateEmployee', obj)
            .then((response) => {
              this.working.wUpdate = false
              this.toast.success = true
              this.$v.userForm.$reset()
              this.$emit('updated', response.data.entity)
              this.close()
            })
            .catch((error) => {
              this.working.wUpdate = false
              this.toast.failed = true

              if (error.response) {
                switch (error.response.data.message) {
                  case 'Email is being used by another collaborator':
                    this.toast.eMessage =
                      'El correo ya existe como colaborador, por favor añade uno nuevo.'
                    break
                  default:
                    this.toast.eMessage =
                      'No se pudo registrar debido a que el correo es inválido o inexistente o está deshabilitado, por favor verifica que sea correcto..'
                }
              }
              console.log(error)
              // console.log(this.toast.eMessage)
            })
        }
      }
    },
    close() {
      this.$v.userForm.$reset()
      this.userForm = {
        firstName: '',
        lastName: '',
        mail: '',
        webRole: 0,
      }
      document.getElementById('img_edit_employee').innerHTML = ``
      document.getElementById('img_edit_employee').style.display = 'none'
      document.getElementById('img_edit_employee_default').style.display =
        'block'
      this.$emit('input', !this.value)
      this.flags.changed = false
    },
  },
  computed: {
    emailErrors() {
      const errors = []
      if (!this.$v.userForm.mail.$dirty) return errors
      !this.$v.userForm.mail.required && errors.push('Correo obligatorio')
      !this.$v.userForm.mail.email && errors.push('Correo inválido')
      return errors
    },
    lastNameErrors() {
      const errors = []
      if (!this.$v.userForm.lastName.$dirty) return errors
      !this.$v.userForm.lastName.required &&
        errors.push('Apellidos obligatorios')

      return errors
    },
    nameErrors() {
      const errors = []
      if (!this.$v.userForm.firstName.$dirty) return errors
      !this.$v.userForm.firstName.required && errors.push('Nombre obligatorio')
      return errors
    },
    roleErrors() {
      const errors = []
      if (!this.$v.userForm.webRole.$dirty) return errors
      !this.$v.userForm.webRole.required && errors.push('Rol obligatorio')
      return errors
    },
  },
}
</script>

<style></style>
